module.exports = __webpack_public_path__ + "img/dp.e3553f4b.jpg";